import { ViewModel,View, ObservableArray, ViewModelMessage } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { DataModelBuilderViewModel } from "../datamodel/dataModelBuilder/dataModelBuilder-viewModel";
import { FormBuilderViewModel, GetAllTemplateMessage, IFormBuilderPart } from "./formBuilder/formBuilder-viewModel";
import  { FormBuilderWindowView } from "./formBuilderWindow-view"
import { ViewModelBuilderViewModel } from "./viewModelBuilder/viewModelBuilder-viewModel";

export class FormBuilderWindowViewModel extends WindowViewModel{
    
    public getTitle(): string {
        return 'فرم ساز 2';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.formBuilder = new FormBuilderViewModel(this);
        this.dataModelBuilder = new DataModelBuilderViewModel(this);
        this.parts = ObservableArray.create<IFormBuilderPart>();
        this.parts.push(...[this.formBuilder,this.dataModelBuilder]);
        this.selectedPart = this.formBuilder;
    }
    GetDefaultView(): View <ViewModel> {
        return new FormBuilderWindowView();
    }
    public getTypeId(): string {
        return "VM-EA1E05B4-2F58-41A5-842C-88FAB8C32CDF"
    }

    public set formBuilder(v: FormBuilderViewModel) { this._formBuilder = v; } public get formBuilder(): FormBuilderViewModel { return this._formBuilder;} private _formBuilder: FormBuilderViewModel;
    public set dataModelBuilder(v: DataModelBuilderViewModel) { this._dataModelBuilder = v; } public get dataModelBuilder(): DataModelBuilderViewModel { return this._dataModelBuilder;} private _dataModelBuilder: DataModelBuilderViewModel;
    public set parts(v: ObservableArray<IFormBuilderPart>) { this._parts = v; } public get parts(): ObservableArray<IFormBuilderPart> { return this._parts;} private _parts: ObservableArray<IFormBuilderPart>;
    public set selectedPart(v: IFormBuilderPart) { this._selectedPart = v; } public get selectedPart(): IFormBuilderPart { return this._selectedPart;} private _selectedPart: IFormBuilderPart;

    updateDataModel(){
        let dataModel = this.dataModelBuilder.getDataModelJson();
        this.formBuilder.updateModelFromJson(dataModel);
    }

    getSerializedData() {
        let dataModel = this.dataModelBuilder.getDataModelJson();
        let formData = this.formBuilder.serailize();
        return {
            DataModel : dataModel,
            FormData : formData
        };
    }
    deserialize(info: any) {
        let dataModel = info.DataModel;
        let formData = info.FormData;
        this.dataModelBuilder.updateModelFromJson(dataModel);
        this.formBuilder.updateModelFromJson(dataModel);
        this.formBuilder.deserialize(formData);
    }
    
    override handleMessage(msg:ViewModelMessage){
        if(msg instanceof GetAllTemplateMessage){
            return this.formBuilder.handleMessage(msg);
        }else{
            return super.handleMessage(msg);
        }
    }

}
